import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const state = {
  data: {},
  auth: {result: '', token: null}
}

const mutations = {
  setState (state, data) {
    state.data = {...state.data, ...data}
  },
  resetState (state) {
    state.data = {}
  },
  updateAuth(state, auth) {
    state.auth = auth
  }
}

const actions = {
  async login({ commit }, { user, password, locale }) {
    try {
      const response = await this._vm.$http.post('login', {
        login: {
          user,
          password,
          locale
        }
      })
      commit('updateAuth', response.data)
    } catch (error) {
      console.log(error)
    }
  }
}

const getters = {
  auth(state) {
    return state.auth
  },
  data(state) {
    return state.data
  }
}

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})

createPersistedState({
  key: 'vuex',
  reducer(value) {
    return value
  }
})(store)
export default store
